<template>
  <div class="main">
    <div class="main-content">
      <top></top>
      <Head></Head>
      <main>
        <transition name="fade-transform" mode="out-in">
          <router-view></router-view>
        </transition>
      </main>
      <Footer :data="data"></Footer>
      <login v-if="$store.state.login_show" @close='close1'></login>
      <openvip v-if="$store.state.vip_show"></openvip>
      <backTop></backTop>
    </div>
  </div>
</template>

<script>
  import top from '../components/top.vue'
  import Head from '../../src/components/header'
  import Footer from '../../src/components/footer'
  import login from '../../src/components/login'
  import openvip from '../components/vip.vue'
  import backTop from '../components/backTop.vue'
  export default {
    data() {
      return {
        login_show: this.$store.state.login_show,
        data: []
      }
    },
    components: {
      Head,
      Footer,
      top,
      login,
      openvip,
      backTop
    },
    mounted() {
      this.$http.friendLink().then(res => this.data = res.data.list)
    },
    methods: {
      close1() {
        this.login_show = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .main {
    // overflow-x: scroll;
    margin: 0 auto;
    padding: 0;
  }

  main {
    width: 1280px;
    margin: 0 auto;
    min-height: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/view/main.vue